import { render, staticRenderFns } from "./NewActuacion.vue?vue&type=template&id=30343c1b&scoped=true"
import script from "./NewActuacion.vue?vue&type=script&setup=true&lang=js"
export * from "./NewActuacion.vue?vue&type=script&setup=true&lang=js"
import style0 from "./NewActuacion.vue?vue&type=style&index=0&id=30343c1b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30343c1b",
  null
  
)

export default component.exports